export default "__VITE_ASSET__ee86361c__"